import { render, staticRenderFns } from "./ModuleDetailHeader.vue?vue&type=template&id=323aba62&scoped=true"
import script from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
export * from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetailHeader.vue?vue&type=style&index=0&id=323aba62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323aba62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323aba62')) {
      api.createRecord('323aba62', component.options)
    } else {
      api.reload('323aba62', component.options)
    }
    module.hot.accept("./ModuleDetailHeader.vue?vue&type=template&id=323aba62&scoped=true", function () {
      api.rerender('323aba62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModuleDetailHeader/ModuleDetailHeader.vue"
export default component.exports